module.exports = __webpack_public_path__ + "static/media/sample.cf9a1fe6.csv";